// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"472":"settings","597":"projects","809":"users","884":"admin"}[chunkId] + "." + {"472":"a5430d83","597":"5b10766d","809":"b30d258b","884":"c99007e8"}[chunkId] + ".js";
};